query liabilityEvents(
  $first: Int
  $offset: Int
  $condition: EventCondition,
  $filter: EventFilter,
  $marketsFilter: MarketLiabilityFilter
  $globalMarketsFilter: GlobalMarketLiabilityFilter
  $lineMarketsFilter: AggregatedMarketLiabilityFilter
  $globalLineMarketsFilter: GlobalAggregatedMarketLiabilityFilter
) {
  allEvents(
    first: $first,
    offset: $offset,
    orderBy: STARTS_AT_ASC
    condition: $condition
    filter: $filter
  ) {
    events: nodes {
      eventId
      eventName
      sportId
      competitionId
      competitors
      inLimbo
      competition {
        competitionName
      }
      matchState
      isUsaView
      source
      startsAt

      eventLiabilities: eventLiabilitiesByEventId {
        nodes {
          betsCount
          pnl
          volume
          operatorId
        }
      }
      globalEventLiabilities: globalEventLiabilitiesByEventId {
        nodes {
          betsCount
          pnl
          volume
        }
      }
      lineMarketLiabilities: aggregatedMarketLiabilitiesByEventId(
        filter: $lineMarketsFilter
      ) {
        nodes {
          marketTypeWithoutLine
          marketSummary
          marketCode
          betsCount
          pnl
          volume
          operatorId
        }
      }
      globalLineMarketLiabilities: globalAggregatedMarketLiabilitiesByEventId(
        filter: $globalLineMarketsFilter
      ) {
        nodes {
          marketTypeWithoutLine
          marketSummary
          marketCode
          betsCount
          pnl
          volume
        }
      }
      marketLiabilities: marketLiabilitiesByEventId(
        filter: $marketsFilter
      ) {
        nodes {
          marketCode
          marketSummary
          marketType
          marketId
          betsCount
          pnl
          volume
          operatorId
        }
      }
      globalMarketLiabilities: globalMarketLiabilitiesByEventId(
        filter: $globalMarketsFilter
      ) {
        nodes {
          marketCode
          marketSummary
          marketType
          betsCount
          pnl
          volume
        }
      }
    }
    totalCount
  }
}
